// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"10b8b337","533":"b03dce0a","802":"b8e25957","831":"74086c79"}[chunkId] + ".chunk.js";
};